import React, { useEffect } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import TermsContainer from '../components/TermsContainer/TermsContainer'
import Footer from '../components/Footer/Footer'
import {  Container, Row } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

function Terms() {
  const { pathname } = useLocation();
  const layout = useSelector((state) => state.layoutRducer.layoutArray);

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [pathname]);

  return (
 

    <>
    <NavbarContainer/>
    <Container>
      <Row>
    
        <TermsContainer layout={layout}/>


      </Row>
    </Container>
    <Footer/>
    </>  )
}

export default Terms